// @ts-nocheck
import { Link as ScrollLink } from 'react-scroll';
import { useLocation, Outlet } from 'react-router-dom';
// material
import { Box, Link, Container, Typography } from '@mui/material';
// components
import Logo from '../../components/Logo';
//

import MainNavbar from './MainNavbar';
import DashboardFooter from '../dashboard/DashboardFooter';

// ----------------------------------------------------------------------

// The public shell: home, pricing, terms, privacy.
//
// It used to bounce any signed-in visitor straight to /dashboard on mount, so
// nobody with an account could ever reach the marketing pages — and since every
// layout's logo links to '/', clicking the logo threw you at the dashboard or,
// before that, at the login form. A signed-in person is allowed to read the
// pricing page; the navbar offers them "Dashboard" instead of "Login" so the
// way back into the product is one click, which is what the redirect was
// really trying to provide.
export default function MainLayout() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  return (
    <>
      <MainNavbar />
      <div>
        <Outlet />
      </div>

      {!isHome ? (
        <DashboardFooter />
      ) : (
        <Box
          sx={{
            py: 5,
            textAlign: 'center',
            position: 'relative',
            bgcolor: 'background.default'
          }}
        >
          <Container maxWidth="lg">
            <ScrollLink to="move_top" spy smooth>
              <Logo sx={{ mb: 0, mx: 'auto', cursor: 'pointer' }} />
            </ScrollLink>

            <Typography variant="caption" component="p">
              © All rights reserved
              <br /> made by &nbsp;
              <Link href="https://allarohomes.com.au/">Allaro Homes</Link>
            </Typography>
          </Container>
        </Box>
      )}
    </>
  );
}